import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { BootstrapVue } from 'bootstrap-vue';
import './axios/errorHandler';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/css/style.css';
import './assets/css/animations.css';

/**
 * V2 Assets sass
 */
import './assets/sass/style.scss';

export const bus = new Vue();

Vue.use(BootstrapVue);
Vue.config.productionTip = false;

new Vue({
  router,
  store,

  render: h => h(App)
}).$mount('#app');

export default router;
